// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"providerEntityForm_downloadButton__TOkYN","entity_ref_user_id":"providerEntityForm_entity_ref_user_id__3_Dl-"};